import React from 'react'
import styles from "./Resources.module.scss";
import { impForYourBusiness } from "../../configration_data/configration"
import { useNavigate } from 'react-router-dom';
import ProtectedPaymentRoute from '../../auth/Auth';

export default function Boi() {
  ProtectedPaymentRoute()

  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/services/compliance")
  }

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">

      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            Beneficial Ownership Information (BOI)
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            A guide to Federal BOI requirements, deadlines, reporting exemptions, and staying compliant.
          </p>
        </div>
      </section>

      {/* Overview & Cards */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">Compliance Guide</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">What is BOI and Why is it Important?</h2>
            <p className="text-[17px] text-[#5f6368] leading-relaxed">
              Beneficial Ownership Information (BOI) filing is a regulatory requirement designed to increase transparency in business ownership. Understanding BOI is crucial for compliance and maintaining the integrity of your business.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {impForYourBusiness.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-white rounded-[12px] p-8 border border-[#dadce0] shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
              >
                <div>
                  <div className="w-10 h-10 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                  </div>
                  <h3 className="text-[20px] font-medium text-[#202124] mb-3 tracking-tight">
                    {ele.title}
                  </h3>
                  <p className="text-[#5f6368] text-[15px] leading-relaxed">
                    {ele.para}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Summary Note & Action */}
      <section className="py-20 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl text-center">
          <div className="bg-[#f8f9fa] p-8 lg:p-10 rounded-[12px] border border-[#dadce0]">
            <p className="text-[16px] text-[#3c4043] leading-relaxed mb-6 font-normal">
              For accurate and timely BOI filing, trust Oktobiz to handle your <span className="font-semibold text-[#1a73e8]">BOI filings</span> and ensure full compliance with Federal FinCEN guidelines.
            </p>
            <button 
              onClick={handleClick}
              className="bg-[#1a73e8] text-white px-8 py-3 rounded-[4px] font-medium text-[15px] hover:bg-[#1557b0] transition-colors shadow-md cursor-pointer"
            >
              File Your BOI Report
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
